import { StatsGuardRuleHostname } from './hostname';
import { WindowLocationService } from '../../../../service/window-location/service';

export function StatsGuardRuleHostnameFactory(): StatsGuardRuleHostname {
  return new StatsGuardRuleHostname(WindowLocationService());
}
